<template>
  <li
    class="col-xs-4"
    :class="{ active: boxConfig.trigger_button.kind === 'naked'}"
    @click="boxUpdateConfig({ item: 'trigger_button', key: 'kind', value: 'naked' })"
    >
    <a href="#" class="kp-btn-action-lg-max">
      <i class="kp-panel-btn-naked"></i>
    </a>
    <div class="kp-tab-label">{{$t('general.labels.button')}}<br>{{$t('edit.sidebar.without_style')}}</div>
  </li>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  methods: mapActions([
    'boxUpdateConfig',
  ]),
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Naked.vue?75de0e72
 **/